/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSelect.vue?vue&type=template&id=08d67fa0"
import script from "./popSelect.vue?vue&type=script&lang=js"
export * from "./popSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports